import AboutBrightScope from "./components/AboutBrightScope";
import MissionVision from "./components/MissionVision";
import OurJourney from "./components/OurJourney";
import OurPeople from "./components/OurPeople";
import PeaceOfMind from "./components/PeaceOfMind";

const About = () => {
  return (
    <div className="container">
      <AboutBrightScope />
      <OurJourney />
      <MissionVision />
      <OurPeople />
      <PeaceOfMind />
    </div>
  );
};

export default About;
